/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CentSymbol = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12C1 5.92486 5.92486 1 12 1ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 17.1638 6.83614 21.35 12 21.35C17.1638 21.35 21.35 17.1638 21.35 12C21.35 6.83614 17.1638 2.65 12 2.65ZM12.8064 6V7.76235C14.4246 7.98665 15.5941 9.04406 15.8505 10.8385H14.1362C13.9599 9.89319 13.1589 9.23631 12.1335 9.23631C10.7076 9.23631 9.77837 10.3258 9.77837 11.992C9.77837 13.6742 10.7236 14.7637 12.1335 14.7637C13.1749 14.7637 13.9439 14.1549 14.1362 13.0975H15.8505C15.5621 14.988 14.4085 16.0134 12.8064 16.2376V18H11.2523V16.2056C9.29773 15.8531 8 14.251 8 11.992C8 9.749 9.29773 8.14686 11.2523 7.79439V6H12.8064Z"
                        fill={color}
                    />
                </svg>
        );
    };
